/**
 * Los listados del backend pasaron a responder { items, total, hasMore }
 * en vez de un arreglo suelto, para que nunca devuelvan la tabla entera.
 *
 * Este helper acepta las dos formas: si algun endpoint todavia responde un
 * arreglo, sigue funcionando igual.
 */
export const desempaquetarLista = (data) => {
  if (Array.isArray(data)) {
    return { items: data, total: data.length, hasMore: false };
  }

  const items = Array.isArray(data?.items) ? data.items : [];

  return {
    items,
    total: Number.isFinite(Number(data?.total)) ? Number(data.total) : items.length,
    hasMore: Boolean(data?.hasMore),
  };
};
